import permissions from 'constants/permissions'

const PROFILE_LIST = [
  {
    name: 'Visualizar',
    tag: permissions.ADVISOR_PROFILE.VIEW,
  },
  {
    name: 'Gerenciar',
    tag: permissions.ADVISOR_PROFILE.MANAGE,
  },
]

export default PROFILE_LIST
